















































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required } from 'vuelidate/lib/validators';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
    SwSelect,
  },
  validations: {
    dataCenter: { required },
  },
})
export default class OnPremDialog extends SwExtendedVue {
  @Prop()
  showOnPremDialog: boolean;
  gmsOnPremiseOpt: SelectOption[] = [];
  gmsOnPremise : string = '';
  ztIpText : any = '';
  @Prop()
  onPremDetails: any[];
  submitted: boolean = false;
  closeDialog() {
    this.$emit('closeDialog');
  }
  created() {
    this.gmsOnPremiseOpt = [];
    const inner : any = {};
    inner['id'] = 'default';
    inner['label'] = 'Choose On-Premise GMS Server';
    inner['value'] = 'noChange';
    this.gmsOnPremiseOpt.push(inner);
    this.onPremDetails.forEach((element : any) => {
      const inner : any = {};
      inner['id'] = element.ttserverfqdn;
      inner['label'] = element.displayname;
      inner['value'] = element.policyserver;
      this.gmsOnPremiseOpt.push(inner);
    });
    this.gmsOnPremise = this.gmsOnPremiseOpt[0].id;
  }
  @Watch('gmsOnPremise')
  onDropDownChange(value : any) {
    console.warn(this.gmsOnPremise);
    this.ztIpText = value;
  }
  validateForm() {
    this.submitted = true;
    this.$v.$touch();
    if (this.gmsOnPremise === 'default' || this.ztIpText === '') {
    } else {
      console.warn('got in');
      this.onPremDetails.forEach((each : any) => {
        if (each.ttserverfqdn === this.gmsOnPremise) {
          console.warn(each.ttserverfqdn);
          console.warn(this.gmsOnPremise);
          this.$emit('closeDialog', { ttserverfqdn: this.ztIpText , serialnumber : each.serialnumber });
        }
      });
    }
  }
}
